import { connect } from 'react-redux'
import { State } from '../../../../store'
import PrivateRoutePresentation from '../../PrivateRoutePresentation'

export default connect((state: State) => ({
  isAuthorized: !!state.auth.register.sms.request_body,
  pathname: '/onboarding/investor/provide-details',
}))(PrivateRoutePresentation)
